<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import {client, getFileNameUUID} from "./utils/oss";

  export default {
    name: "app",
    mounted() {
      this.$common.auth();
      this.$common.getIdentity();
    },
    methods:{

    }
  }
</script>

<style>
  html,body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #f5f5f5 !important;
  }
  ol,ul,li{
    list-style:none;
  }
  #app,.app{
    width: 100%;
    height: 100%;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .box-sizing{
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
  }
  .text-align{text-align: center !important;}
  .clear-fix{*zoom:1;}
  .clear-fix:after{content:"\200B"; display:block; height:0; clear:both; }
  .el-popconfirm__main{margin: 10px 0 !important;}
  .mask{position: fixed;top:0;left: 0;right: 0;bottom:0;background-color: #000;opacity: .6;filter:alpha(opacity=60);z-index: 99;}
  .vip-pop{width: 660px;height: 560px;position: absolute;top: 45%;left: 45%;margin-top: -225px;margin-left: -200px;border-radius: 10px;z-index: 999;}
  .vip-pop .wd50{width: 100%;height:40px;background-color: white;}
  .vip-pop .wd40{width: 100%;height:30px;background-color: white;}
  .vip-pop .banner{width: 100%;height: 130px;background-color: #195AF8;border-radius: 20px 20px 0 0;}
  .vip-pop .banner img{width: 100%;height: 100%;border-radius: 20px 20px 0 0;}
  .vip-pop .people{width: 144px;height: 47px;margin-left: 68.7%;}
  .vip-pop .people img{width: 100%;height: 100%;}
  .vip-pop .square-box{background-color:white;width: 100%;height: 200px;text-align: center;font-size: 0;}
  .vip-pop .square-box div{float: left;overflow: hidden;display: inline-block}
  .vip-pop .square-box .title{font-size: 16px;margin-top: 29px;margin-left: 20px;font-weight: bold}
  .vip-pop .square-box .content{font-size: 14px;margin-top: 60px;text-align: left;margin-left: 20px;color: #6A6A6A}
  .vip-pop .square-box span{margin-bottom:12px;margin-right:10px;width: 190px;height: 100px;display: inline-block;border-radius: 10px;background-color: #EEF6FF;vertical-align: top;text-align: center;letter-spacing:0;font-size: 14px;}
  .vip-pop .square-box img{float: right;margin-top: 26px;margin-right: 20px}
  .vip-pop .square-box span i{font-size: 30px;display: inline-block;width: 30px;height: 30px;color: #3A92FC;margin-top: 15px;margin-bottom: 5px;}
  .vip-pop .more-message{background-color: white;float: right;display: block;margin-right: 40px}
  .vip-pop .more-message a{color: #008DF2}
  .vip-pop .btn-box{background-color:white;width: 100%;height: 70px;border-radius: 0 0 20px 20px;padding-top: 20px;}
  .vip-pop .btn-box a{display: block;margin: 0 auto;border-radius: 10px;letter-spacing:5px;line-height: 50px;text-align: center;}
  .vip-pop .btn-box a:nth-child(1){color: white;background-color: #008DF2;font-size: 20px;width: 260px;height: 50px}
  .vip-pop .btn-box a:nth-child(2){margin-top: 20px;color: #FFFFFF;background-color: #3A92FC;font-size: 18px;}
  .vip-pop .close-btn{width: 30px;height: 30px;position: absolute;left: 110%;margin-left: -15px;cursor:pointer;}
  .vip-pop .close-btn i{font-size: 30px;color: #FFFFFF;}
</style>
